import React, { useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import products from "../../data/products";
import "./ProductDetails.css";
import { FaArrowLeft, FaFilePdf } from "react-icons/fa";
import PdfViewerModal from "../common/PdfViewerModal";

function ProductDetails() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isPdfModalOpen, setIsPdfModalOpen] = useState(false);

  // Ensure id matches even if stored as number or string
  const product = products.find((p) => String(p.id) === String(id));

  // If product not found
  if (!product) {
    return (
      <h2 className="text-center mt-5" style={{ color: "red" }}>
        Product Not Found
      </h2>
    );
  }

  return (
    <div className="productmain">
      {/* ---------- TITLE SECTION ---------- */}
      <div className="title-section-Products">
        <p className="small-text-Products" onClick={() => navigate(-1)}>
          <FaArrowLeft /> BACK
        </p>

        <div className="title-section-Products1">{product.name.toUpperCase()}</div>

        <Link to="/" className="Link">HOME</Link>
        <span>/</span>
        <span>PRODUCTS</span>
      </div>

      {/* ---------- DESCRIPTION ---------- */}
      <p className="product-desc">{product.description}</p>

      {/* ---------- PRODUCT DETAILS ---------- */}
      <div className="product-details">

        {/* LEFT: IMAGE */}
        <div className="product-info">
          <img
            src={product.image}
            alt={product.name}
            className="product-img"
          />
          <div className="product-pdf-action">
            <button
              type="button"
              className="btn-details-pdf"
              onClick={() => setIsPdfModalOpen(true)}
              title="View Product Details"
            >
              <FaFilePdf className="pdf-icon" /> View Details
            </button>
          </div>
        </div>

        {/* RIGHT: SPECIFICATIONS */}
        {product.specifications?.length > 0 && (
          <div className="specs-container">
            <h2>SPECIFICATIONS</h2>
            <table className="specs-table">
              {/* <thead>
                <tr>
                  <th>Description</th>
                  <th>Material</th>
                </tr>
              </thead> */}
              <tbody>
                {product.specifications.map((spec, index) => (
                  <tr key={index}>
                    <td>{spec.description}</td>
                    <td>{spec.material}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* IN-APP PDF VIEWER & DOWNLOADER MODAL */}
      <PdfViewerModal
        isOpen={isPdfModalOpen}
        onClose={() => setIsPdfModalOpen(false)}
        pdfUrl={product.pdf}
        title={`${product.name} - Catalogue`}
        productName={product.name}
        productImage={product.image}
        productType={product.type}
      />
    </div>
  );
}

export default ProductDetails;

